"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Payments_1 = require("../Payments");
var Discount_1 = require("../Discount");
var CartDiscountBaseLine_1 = require("./CartDiscountBaseLine");
var BundleCartDiscountLine = /** @class */ (function (_super) {
    __extends(BundleCartDiscountLine, _super);
    function BundleCartDiscountLine(params) {
        var _this = _super.call(this, { referenceDiscount: params.referenceDiscount }, params.mappedCategories) || this;
        _this.mappedBundleProductLines = mobx_1.observable.map();
        _this.setTargetedPaymentLines = function (payment) {
            var copiedNonBundleProductLines = _this.copyNonBundlePaymentLines(payment);
            _this.mappedBundleProductLines.clear();
            var targetedPaymentLines = copiedNonBundleProductLines.filter(function (pl) {
                // i.e. Included by categoryId but excluded by productId
                var shouldBeExcluded = _this.shouldBeExcluded(pl.productId, pl.categoryId);
                var shouldBeTargeted = _this.shouldBeTargeted(pl.productId, pl.categoryId);
                return !shouldBeExcluded && shouldBeTargeted;
            });
            if (targetedPaymentLines.length === 0)
                return;
            var minInventorySubtracted = Math.min.apply(Math, __spread(targetedPaymentLines.map(function (tpl) { return tpl.inventorySubtracted; })));
            targetedPaymentLines.forEach(function (tpl) {
                if (tpl.productId) {
                    tpl.setInventorySubtracted(minInventorySubtracted);
                    tpl.removeDiscount();
                    tpl.setBundleDiscountLine(_this);
                    _this.mappedBundleProductLines.set(tpl.productId, tpl);
                }
            });
        };
        _this.copyNonBundlePaymentLines = function (payment) {
            var paymentLines = [];
            payment.nonBundleProductLines.forEach(function (paymentLine) {
                if (!paymentLine.product)
                    return;
                var params = {
                    product: paymentLine.product,
                    pricePerInventorySubtracted: paymentLine.pricePerUnit,
                    inventoryToSubtract: paymentLine.inventorySubtracted,
                    inventorySubtractIncrement: paymentLine.product.inventorySubtractAmount,
                    maximumQuantity: paymentLine.maximumQuantity,
                    barcode: paymentLine.barcode || null,
                    batchId: paymentLine.batchId || undefined,
                    batchNumber: paymentLine.batchNumber,
                };
                var newPaymentLine = payment.createPaymentLine(params);
                paymentLines.push(newPaymentLine);
            });
            return paymentLines;
        };
        _this.getLineSubTotal = function () {
            var lineSubTotal = _this.paymentLines.reduce(function (acc, pl) { return acc + pl.price; }, 0);
            return lineSubTotal;
        };
        _this.getProRatedBundleDiscount = function (productId) {
            if (productId === null) {
                return 0;
            }
            var lineSubTotal = _this.getLineSubTotal();
            var bundlePaymentLine = _this.mappedBundleProductLines.get(productId);
            if (!bundlePaymentLine) {
                return 0;
            }
            var proRate = bundlePaymentLine.price === 0
                ? 0
                : bundlePaymentLine.price / lineSubTotal;
            return proRate * _this.discountPrice;
        };
        _this.name = params.name;
        _this.discountType = params.discountType;
        _this.discountFixed = Math.abs(params.discountFixed) * -1;
        _this.discountPercentage = params.discountPercentage;
        _this.referenceDiscount = params.referenceDiscount;
        _this.mappedCategories = params.mappedCategories;
        _this.setTargetedPaymentLines(params.payment);
        return _this;
    }
    Object.defineProperty(BundleCartDiscountLine.prototype, "paymentLines", {
        get: function () {
            return __spread(this.mappedBundleProductLines.values());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BundleCartDiscountLine.prototype, "targetMinUnitSold", {
        get: function () {
            return Math.min.apply(Math, __spread(this.paymentLines.map(function (pl) { return pl.inventorySubtracted; })));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BundleCartDiscountLine.prototype, "discountId", {
        get: function () {
            return this.referenceDiscount ? this.referenceDiscount.id : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BundleCartDiscountLine.prototype, "productName", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BundleCartDiscountLine.prototype, "discountPrice", {
        get: function () {
            var lineSubTotal = this.getLineSubTotal();
            var discountPrice = this.discountType === Discount_1.DiscountTypes.PERCENT
                ? Math.abs(Math.round(lineSubTotal * (this.discountPercentage / 100))) * -1
                : this.discountFixed;
            var isDiscountAmountValid = Math.abs(lineSubTotal) > Math.abs(discountPrice);
            if (!isDiscountAmountValid) {
                var minAllowableCannabisDiscountedPrice = this.paymentLines.reduce(function (acc, curr) { return acc + (curr.complianceCategoryId ? curr.inventorySubtracted : 0); }, 0);
                var amountRequiredUntilMinimumPrice = minAllowableCannabisDiscountedPrice - lineSubTotal;
                discountPrice = Math.abs(amountRequiredUntilMinimumPrice) * -1;
            }
            return discountPrice;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BundleCartDiscountLine.prototype, "includedPaymentLines", {
        get: function () {
            return this.paymentLines;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BundleCartDiscountLine.prototype, "excludedPaymentLines", {
        get: function () {
            var _this = this;
            return this.paymentLines.filter(function (pl) {
                return pl.type === Payments_1.PaymentLineType.LOYALTY
                    ? false
                    : _this.shouldBeExcluded(pl.productId, pl.categoryId);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BundleCartDiscountLine.prototype, "networkTransferObject", {
        get: function () {
            return {
                type: this.type,
                productId: null,
                productName: this.name,
                units: 1,
                unit: 'unit',
                inventorySubtracted: 1,
                price: 0,
                depositFee: null,
                discountId: this.discountId,
                discountPrice: Math.round(this.discountPrice),
                discountMessage: null,
                cartDiscountPrice: 0,
                barcode: null,
                shortDescription: null,
                batchId: null,
                sku: null,
                loyaltyCost: this.loyaltyCost
            };
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], BundleCartDiscountLine.prototype, "mappedBundleProductLines", void 0);
    __decorate([
        mobx_1.computed
    ], BundleCartDiscountLine.prototype, "paymentLines", null);
    __decorate([
        mobx_1.action
    ], BundleCartDiscountLine.prototype, "setTargetedPaymentLines", void 0);
    __decorate([
        mobx_1.computed
    ], BundleCartDiscountLine.prototype, "targetMinUnitSold", null);
    __decorate([
        mobx_1.computed
    ], BundleCartDiscountLine.prototype, "discountId", null);
    __decorate([
        mobx_1.computed
    ], BundleCartDiscountLine.prototype, "productName", null);
    __decorate([
        mobx_1.computed
    ], BundleCartDiscountLine.prototype, "discountPrice", null);
    __decorate([
        mobx_1.computed
    ], BundleCartDiscountLine.prototype, "includedPaymentLines", null);
    __decorate([
        mobx_1.computed
    ], BundleCartDiscountLine.prototype, "excludedPaymentLines", null);
    __decorate([
        mobx_1.computed
    ], BundleCartDiscountLine.prototype, "networkTransferObject", null);
    return BundleCartDiscountLine;
}(CartDiscountBaseLine_1.CartDiscountBaseLine));
exports.BundleCartDiscountLine = BundleCartDiscountLine;
//# sourceMappingURL=BundleCartDiscountLine.js.map